"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fluidLayoutDescriptor = exports.FluidLayoutDescriptor = void 0;
// keep in sync with sdk-ui-dashboard
var DASHBOARD_LAYOUT_GRID_COLUMNS_COUNT = 12;
var GRID_ROW_HEIGHT_IN_PX = 20;
/**
 * @alpha
 */
var FluidLayoutDescriptor = /** @class */ (function () {
    function FluidLayoutDescriptor() {
        this.gridColumnsCount = DASHBOARD_LAYOUT_GRID_COLUMNS_COUNT;
        this.gridRowHeight = GRID_ROW_HEIGHT_IN_PX;
    }
    FluidLayoutDescriptor.prototype.toGridHeight = function (heightPx) {
        return Math.round(heightPx / this.gridRowHeight);
    };
    FluidLayoutDescriptor.prototype.toHeightInPx = function (height) {
        return height * this.gridRowHeight;
    };
    return FluidLayoutDescriptor;
}());
exports.FluidLayoutDescriptor = FluidLayoutDescriptor;
/**
 * @alpha
 */
exports.fluidLayoutDescriptor = new FluidLayoutDescriptor();
//# sourceMappingURL=FluidLayoutDescriptor.js.map